import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { PrimaryButton, CancelButton } from "@/components/buttons";
import { SendUserFeedbackDocument } from "owfsa-graphql";
import { useMutation } from "@urql/vue";
import { isEmpty } from "lodash";
import { computed, ref } from "vue";
import { toast } from "vue-sonner";

const maxChars = 2000;

export default /*@__PURE__*/_defineComponent({
  __name: 'UserFeedback',
  props: {
    "modelValue": { type: Boolean, ...{ default: false } },
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
  __expose();

const sendUserFeedback = useMutation(SendUserFeedbackDocument);

const drawer = _useModel<boolean>(__props, "modelValue");
const message = ref();
const rating = ref();
const isSubmitting = ref();

const valid = computed(
  () => !isEmpty(message.value)
    && rating.value
    && message.value.length <= maxChars,
);

const closeDrawer = () => {
  rating.value = null;
  message.value = null;
  drawer.value = false;
};

const submit = async () => {
  isSubmitting.value = true;

  const result = await sendUserFeedback.executeMutation({
    message: message.value,
    rating: rating.value,
  });

  if (!result.error && !!result.data) {
    toast.success("Your feedback has been submitted. Thank you.");
    closeDrawer();
  } else {
    toast.error(
      "An error has occurred while submitting feedback. Please contact your admin.",
    );
  }

  isSubmitting.value = false;
};


const __returned__ = { maxChars, sendUserFeedback, drawer, message, rating, isSubmitting, valid, closeDrawer, submit, get PrimaryButton() { return PrimaryButton }, get CancelButton() { return CancelButton } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})